import React, { Component } from 'react';
import {Button, Form, Modal, Row, Col} from 'react-bootstrap';
import InputText from '../common_components/InputText';
import TabContainer from '../common_components/TabContainer.js';
import DataGrid from '../common_components/DataGrid.js';
import DataDropdown from '../common_components/DataDropdown.js';
import {mapArrayToObject, getAPI, postAPI, validateForm, showFormValidationAlert} from '../common_components/common.js';
import ViscosityCups from './ViscosityCups';
import ContactTypes from './ContactTypes';
import TabItem from '../home/TabItem.js';
import Config from '../Config';
const { Translate } = require('react-i18nify');

export default class Administration extends Component {
	constructor(props){
		super(props);

		this.state = {
		};

	}
	render(){
		
		const tabTitles = [
			<Translate value="components.settings.substrates" />,
			<Translate value="components.settings.viscosityCups" />,
			<Translate value="components.settings.contactPositions" />,
		];
		
		const tabs = [
			<Substrates search={this.props.search} />,
			<ViscosityCups search={this.props.search} />,
			<ContactTypes search={this.props.search} />,
		];
	
		return (
			<div>
			<TabContainer tabTitles={tabTitles} tabs={tabs}/>
			</div>
		);
	}
}

class Substrates extends Component {
	constructor(props) {
		super(props);

		this.state = {
			// apiUrl: Config.baseURL + 'administration/substrates/list',
			apiUrl: Config.baseURL + 'common/substrates',
			columns: [
				<Translate value='components.settings.substrateName' />,
			],
			fields: ['name'],
			formatColumns: {},
			data: [],
			offset: 0,
			limit: 2500,
			showNewSubstrateForm: false,
			editSubstrateId: null,
			loading: true,
			autoRefresh: true,
			interval: null,
			substrateRetired: '0',
		};
		this.showEditSubstrateForm = this.showEditSubstrateForm.bind(this);
		
	}
	
	refreshData() {
		this.setState({loading: true});
		getAPI("common/substrates").then(resSubstrates => {
			this.setState({
				data: resSubstrates['data'],
				loading: false,
			});
		});	
	}

	componentDidMount() {
		this.refreshData();	
		
		const interval = setInterval(async () => {
			if(this.state.autoRefresh && !this.state.showNewSubstrateForm) {
				this.refreshData();	  
			}
		}, Config.keepConnInterval);
		this.setState({interval: interval});
	}
	
	componentWillUnmount() {
		clearInterval(this.state.interval);
	}
	
	showEditSubstrateForm(dataIn) {
		this.setState({
			editSubstrateId: dataIn['id'],
			showNewSubstrateForm: true,
		});
	}


	
	render() {
		let data = this.state.data;
		
		if(this.state.substrateRetired != '')
		{
			// console.log("this.state.substrateRetired: ", this.state.substrateRetired, ", data: ", data);
			data = data.filter(obj => obj.retired == this.state.substrateRetired);
		}
		
		if(this.props.search != undefined)
		{
			data = data.filter(obj => 
				obj.name.toLowerCase()
					.indexOf(this.props.search.toLowerCase()) > -1 
			);
		}
		const editSubstrateForm = this.state.showNewSubstrateForm ? <NewSubstrateForm
					visible={this.state.showNewSubstrateForm}
					onClose={() => this.setState({showNewSubstrateForm: false})}
					onSave={() => {
						this.setState({showNewSubstrateForm: false});
						this.refreshData();
					}}
					editSubstrateId={this.state.editSubstrateId}
				/> : "";
	
		return(<div>
			<DataGrid
				columns={this.state.columns}
				fields={this.state.fields}
				data={data}
				formatColumns={this.state.formatColumns}
				onDoubleClick={this.showEditSubstrateForm}
				loading={this.state.loading}
				heightOffset={190}
			/>
			<Row>
				<Col md="2"></Col>
				<Col md="4">
					<Form class='form-page' horizontal>
						<DataDropdown 
							label={<Translate value="components.labels.type" />} 
							action={(event) => {
								// console.log("event: ", event.target.value);
								this.setState({substrateRetired: event.target.value});
							}} 
							data={{'0': 'Active', '1': 'Inactive'}} 
							value={this.state.substrateRetired}
						/>
					</Form>
				</Col>
				<Col md="4">
					<Button bsSize='sm' onClick={() => this.setState({showNewSubstrateForm: true, editSubstrateId: null})}>
				<Translate value='components.settings.newSubstrate' />
			</Button>
				</Col>
			</Row>
			
			{editSubstrateForm}
		</div>);
	}
}

class DeleteConfirmation extends Component {
	onDelete() {
		this.props.onConfirm();
		this.props.onClose();
	}

	render() {
		return(<Modal show={this.props.visible}>
			<Modal.Body><Translate value='components.labels.deleteSubstrateConfirmationPrompt' /></Modal.Body>
			<Modal.Footer>
				<Button bsStyle='danger' onClick={() => this.onDelete()}><Translate value='components.buttons.delete' /></Button>
				<Button onClick={this.props.onClose}><Translate value='components.buttons.cancel' /></Button>
			</Modal.Footer>
		</Modal>);
	}
}
const validationFields = {
	name: "required",
};

class NewSubstrateForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errors: {},
			formData: {
				id: 0,
				value: "",
				name: "",
				code: "SUBSTRATE_TYPE",
				category: "",
				retired: false,
			},
			showDeleteConfirmation: false,
		};
		this.handleInputChanged = this.handleInputChanged.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onDelete = this.onDelete.bind(this);
	}
	
	componentDidMount() {
		if(this.props.editSubstrateId) {
			let formData = this.state.formData;
			const substrateId = this.props.editSubstrateId;
			getAPI("/common/substrates/" + substrateId).then(resSubstrate => {
				formData = resSubstrate['data'][0];
				this.setState({
					formData: formData,
				});
			});
		}
	}

	handleInputChanged(event, name) {
		const target = event.target;
		var value = target.type === 'checkbox' ? target.checked : target.value;
		var formData = this.state.formData;
		formData[name] = value;
		
		switch(name) {
			case 'name':
				formData['value'] = value;
				break;
		}
		
		this.setState({
		  formData: formData,
		});
	}
	
	onSave() {
		let validation = validateForm(this.state.formData, validationFields);
		
		// IF FORM IS NOT VALIDATED, THEN SET STATE ACCORDINGLY
		if(!validation.result)
		{
			showFormValidationAlert(validation.errors);
			this.setState({
				errors: validation.errors
			});
		}
		else
		{
			postAPI("common/substrates", this.state.formData).then(resSubstrate => {
			if(resSubstrate['success']) {
				alert("Substrate info Saved successfully.");
				this.props.onSave();
			}
			else
			{
				alert(resSubstrate['error']);
			}
		});
		}
	}
	
	onDelete() {
		postAPI("common/substrates/" + this.state.formData.id, this.state.formData).then(resSubstrate => {
			// alert(<Translate value="components.labels.poDeleted" />);
			alert("Substrate has been deleted successfully");
			this.props.onSave();
		});
	}

	render() {
		const content = 
		<Form className='form-page' horizontal>
			<InputText required label={<Translate value='components.settings.name' />} 
				name={'name'} value={this.state.formData.name} 
				action={this.handleInputChanged} 
				errMsg={this.state.errors.name ? this.state.errors.name : ""}
			/>
			<InputText label={<Translate value='components.settings.category' />} name={'category'} value={this.state.formData.category} action={this.handleInputChanged} />
			<InputText type='CheckBox' label={<Translate value='components.settings.inactive' />} name={'retired'} value={this.state.formData.retired} action={this.handleInputChanged}/>
		</Form>
				
		return(<Modal show={this.props.visible}>
			<Modal.Header>
				<Modal.Title><Translate value='components.settings.newSubstrate' /></Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{content}
				<DeleteConfirmation
					visible={this.state.showDeleteConfirmation}
					onConfirm={this.onDelete}
					onClose={() => this.setState({showDeleteConfirmation: false})}
				/>
			</Modal.Body>
			<Modal.Footer>
				{ false && this.props.editSubstrateId ? <Button bsStyle='danger' onClick={() => this.setState({showDeleteConfirmation: true})}>
					<Translate value="components.buttons.deleteSubstrate" />
				</Button> : ''}
				<Button onClick={this.props.onClose}>{<Translate value='components.settings.close' />}</Button>
				<Button onClick={this.onSave} bsStyle='primary'>{<Translate value='components.settings.saveChanges' />}</Button>
			</Modal.Footer>
		</Modal>);
	}
}

